var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.05.625c-2.099 0-2.806 1.503-4.065 1.635C7.725 2.128 7.018.625 4.94.625c-10.783 0-.177 14.296 4.044 5.17C13.227 14.921 23.81.625 13.05.625zM2.444 4.293c1.216-.95 4.64-1.768 4.64 0 0 .817-.729 1.083-1.612 1.038l-.2.995-.287 1.37-.265-1.37-.243-1.127c-.773-.199-1.569-.53-2.033-.906zm8.618 0c0-1.768 3.403-.95 4.618 0-.53.442-1.503.84-2.43.994l-.177.862-.266 1.37-.287-1.37-.155-.818c-.75-.022-1.303-.309-1.303-1.038z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default ForwardRef;